import React, { useEffect, useState } from "react";
import { IoStar } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import Header from "../../components/layout/header";
import Footer from "../../components/layout/footer";
import "./Wishlist.css";
import { FaRegHeart, FaHeart } from "react-icons/fa";
import axios from "axios";
import { BASE_URL } from "../../constant";
import wishlistImg from "../../images/wishlist-icon.jpg";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useWishlistContext } from "../../Context/WishlistContext";
import FlashSale from "../Flash Sale/FlashSale";
import { useCartContext } from "../../Context/CartContext";
import { RxMagnifyingGlass } from "react-icons/rx";

const SaleProducts = () => {
  const userId = localStorage.getItem("userId");
  const navigate = useNavigate();
  const stars = Array.from({ length: 5 });
  const [saleProducts, setSaleProducts] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [wishlistItems, setWishlistItems] = useState([]);
  const { fetchCartCount } = useCartContext();
  const { fetchWishlistCount } = useWishlistContext();
  const [selectedImage, setSelectedImage] = useState(null);

  const fetchSaleProducts = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/products/deal-of-day-products`);
      setSaleProducts(response.data);
      console.log(response.data);
    } catch (error) {
      console.error("Error fetching sale products:", error);
    }
  };

  const fetchCartItems = async () => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      try {
        const response = await axios.post(
          `${BASE_URL}/usercart/in-cart?userId=${userId}&pageSize=10000`
        );
        setCartItems(response.data);
      } catch (error) {
        console.error("Error fetching cart items:", error);
      }
    }
  };

  const fetchWishlistItems = async () => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      try {
        const response = await axios.get(`${BASE_URL}/wishlist/get/${userId}`);
        setWishlistItems(response.data);
      } catch (error) {
        console.error("Error fetching wishlist items:", error);
      }
    }
  };

  const handleAddToCart = async (productId) => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      try {
        await axios.post(
          `${BASE_URL}/usercart/add-product?userId=${userId}&productId=${productId}&orderQuantity=1`
        );
        console.log("suc");
        await fetchCartCount();
        toast.success("Product added to cart");
        fetchCartItems();
      } catch (error) {
        console.error("Error adding product to cart:", error);
        toast.error("Something went wrong! Try again later");
      }
    } else {
      navigate("/login");
    }
  };

  const handleAddToWishlist = async (productId) => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      try {
        await fetch(
          `${BASE_URL}/wishlist/add/${userId}`,
          {
            method: "POST",
            headers: {
              contentType: "application/json",
            },
            body: productId,
          }
        );
        setWishlistItems((prevWishlist) => [...prevWishlist, { productId }]);
        await fetchWishlistCount();
        toast.success("Product added to wishlist");
        fetchWishlistItems();
      } catch (error) {
        console.error("Error adding product to wishlist:", error);
        toast.error("Something went wrong! Try again later");
      }
    } else {
      navigate("/login");
    }
  };

  const removeWishlistItem = async (productId) => {
    const userId = localStorage.getItem("userId");
    try {
      await axios.delete(
        `${BASE_URL}/wishlist/delete/${userId}/${productId}`
      );
      setWishlistItems((prevWishlist) =>
        prevWishlist.filter((item) => item.productId !== productId)
      );
      await fetchWishlistCount();
      toast.error("Product removed from wishlist");
      fetchWishlistItems();
    } catch (error) {
      console.error("Error removing product from wishlist:", error);
      toast.error("Something went wrong! Try again later");
    }
  };
  const openImageModal = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  useEffect(() => {
    fetchSaleProducts();
    fetchWishlistItems();
    fetchCartItems();
  }, [userId]);

  return (
    <div>

      <Header />
      <ToastContainer />
      <div className="wishlist-container">
        {saleProducts.length > 0 ? (
          <div className="wishlist-top">
            <h1>Sale Products</h1>
          </div>
        ) : (
          ""
        )}

        {saleProducts.length > 0 ? (
          <div className="wishlist-product-items">
            {saleProducts.map((item) => {
              const firstPhotoUrl = item.productPhotos && item.productPhotos.length > 0 ? item.productPhotos[0].photoName : '';
              const isInCart = cartItems.some(cartItem => cartItem.productid === item.productId);
              const isInWishlist = wishlistItems.some(wishlistItem => wishlistItem.productId === item.productId);
              return (
                <div key={item.productId} className="wishlist-product-card">
                  <div className="wishlist-product-image">
                    <img
                      src={firstPhotoUrl}
                      alt={item.productName}
                      onClick={() => navigate(`/productdetails/${item.productId}`)}
                    />
                    <RxMagnifyingGlass
                      className="zoom-icon"
                      onClick={() => openImageModal(firstPhotoUrl)}
                    />
                    {/* <RxMagnifyingGlass
                      id="magnifying-glass-icon"
                      onClick={() => openModal(product.productPhotos[0]?.photoName)}
                    /> */}
                  </div>
                  <div className="wishlist-product-info">
                    <h2 className="wishlist-product-name">{item.productName}</h2>
                    <p className="wishlist-product-description">
                      {item.prdDesc}
                    </p>
                    <div className="price">
                      <span style={{ display: "flex", gap: "10px" }}>
                        <p style={{ textDecoration: "line-through" }}>
                          Rs {item.mrp}
                        </p>
                        <p>Rs {item.purRate}</p>
                      </span>
                    </div>
                    <div className="wishlist-product-icons">
                      {stars.map((_, index) => (
                        <IoStar key={index} />
                      ))}
                      <p style={{ color: "black" }}>(145)</p>
                    </div>
                    <div className="wishlist-product-card-btn">
                      {item.minStk > 0 ? (
                        isInCart ? (
                          <button
                            className="wishlist-add-to-cart"
                            style={{ background: "#0BDA51 " }}
                          >
                            Added to Cart
                          </button>
                        ) : (
                          <button
                            className="wishlist-add-to-cart"
                            onClick={() => handleAddToCart(item.productId)}
                          >
                            Add to Cart
                          </button>
                        )
                      ) : (
                        <button className="wishlist-add-to-cart" disabled>
                          Out of Stock
                        </button>
                      )}
                      {isInWishlist ? (
                        <button
                          className="wishlist-add-to-wishlist"
                          onClick={() => removeWishlistItem(item.productId)}
                        >
                          <FaHeart size={20} style={{ color: "red" }} />
                        </button>
                      ) : (
                        <button
                          className="wishlist-add-to-wishlist"
                          onClick={() => handleAddToWishlist(item.productId)}
                        >
                          <FaRegHeart size={20} />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="empty-wishlist">
            <img src={wishlistImg} width={"200px"} alt="Empty sale products" />
            <h3 style={{ fontSize: "30px" }}>No Sale Products</h3>
            <p style={{ fontSize: "20px" }}>
              Check back later for exciting deals.
            </p>
            <button
              className="empty-cart-btn"
              type="submit"
              onClick={() => navigate("/shop?category=men")}
            >
              Shop Now
            </button>
          </div>
        )}
        {selectedImage && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content">
              <img src={selectedImage} alt="Zoomed Product" />
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default SaleProducts;
